module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=NU - Niue.a022d884.svg";